import { Notifications as NotificationList } from '@acceso/design-system';

import { useNotificationStore } from '@/stores/notifications';

export function Notifications() {
  const { notifications, dismissNotification } = useNotificationStore();

  return <NotificationList notifications={notifications} onDismiss={dismissNotification} />;
}
